import React from 'react';
import classNamesBind from "classnames/bind";
import styles from './EdutechKoreaFairCompanyDataViewHeader.module.scss';
import { CompanyData } from '../../../../../graphql/customScalars';
import { Kotra } from '../../../../../graphql/types';
import { OnChangeValue } from '../../../../Intefaces';
import { BizCompanyDataViewHeaderInteraction } from '../../../../shares/bizCompanyDataView/header/interaction/BizCompanyDataViewHeaderInteraction';
import { BizTitle } from '../../../../shares/bizTitle/BizTitle';
import { BizCompanyDataHeaderTable } from '../../../../shares/bizCompanyDataView/header/BizCompanyDataViewHeader';

const cx = classNamesBind.bind(styles);

interface Props {
    companyData: CompanyData,
    kotra?: Kotra
    companyUserId?: number,
    onCreateChatRoomWithCompanyId?: OnChangeValue<number>
}

export const EdutechKoreaFair2024CompanyDataViewHeader = (props: Props) => {
    return (
        <>
            <div className={cx('box-img', 'p-r-30', 'm-b-30')} style={{marginBottom: 30}}>
                <div className={cx('img-logo')} >
                    <img src={props.companyData.logoUrl} alt=""/>
                </div>
                <BizCompanyDataViewHeaderInteraction
                    onCreateChatRoomWithCompanyId={props.onCreateChatRoomWithCompanyId}
                    companyUserId={props.companyUserId}
                    companyData={props.companyData}/>
            </div>
            <div className={cx('box-info', 'm-b-30')} style={{marginBottom: 30}}>
                <BizTitle>
                    {props.companyData.companyNm}
                </BizTitle>

                <BizCompanyDataHeaderTable {...props}/>
            </div>

        </>
    )
}
